// Whether the page is being prerendered (scripts/prerender.mjs sets the flag): what's on it then is saved as the page
// that search engines, and visitors before the app loads, get.
export const prerendering = () => (window as { __TRISTAR_PRERENDER__?: boolean }).__TRISTAR_PRERENDER__ === true;
